exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".stickyfixed{position:fixed;z-index:20}.XVsticky-container{margin-top:-15px}", ""]);

// exports
